import React from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./Header.css";
import logo from "../../img/logo192.png";

const Header = () => {
  return (
    <div>
      <div className="d-flex bg-success align-items-center justify-content-center text-white px-5">
        <div>
          <p className="mb-0 fw-normal">NEXT BIG EVENT (MAHFIL):</p>
        </div>
        <div className="d-flex px-3">
          <p className="px-3 custom-color py-3 mb-0  mx-2">
            02 <span className="fw-lighter">DAYS</span>
          </p>
          <p className="px-3 custom-color py-3 mb-0  mx-2">
            19 <span className="fw-lighter">HOURS</span>
          </p>
          <p className="px-3 custom-color py-3 mb-0  mx-2">
            26 <span className="fw-lighter">MINUTES</span>
          </p>
          <p className="px-3 custom-color py-3 mb-0  mx-2">
            52 <span className="fw-lighter">SECONDS</span>
          </p>
        </div>
      </div>

      <Navbar expand="lg">
        <Container fluid>
          <img
            src={logo}
            width="150px"
            height="150px"
            className="logo-size"
            alt=""
          />
          <Navbar.Brand href="#" className="fs-2 header-text text-success">
            Ahsanul Uloom <br /> Cadet Madrasha
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="navbarScroll" />
          <Navbar.Collapse id="navbarScroll">
            <Nav
              className="m-auto my-2 my-lg-0 "
              style={{ maxHeight: "150px" }}
              navbarScroll
            >
              <Nav.Link as={Link} to="/home" className="fs-4 active">
                Home
              </Nav.Link>
              <Nav.Link as={Link} to="/courses" className="fs-4 ps-4 active">
                Courses
              </Nav.Link>
              <Nav.Link as={Link} to="/about" className="fs-4 ps-4 active">
                About
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/registration"
                className="fs-4 ps-4 active"
              >
                Registration
              </Nav.Link>
              <Nav.Link as={Link} to="/contactus" className="fs-4 ps-4 active">
                Contact Us
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
        <button type="button" className="btn btn-success py-2 px-4 m-3 me-2">
          Login
        </button>
        <button
          type="button"
          className="btn btn-outline-success py-2 px-4 m-3 me-5"
        >
          Register
        </button>
      </Navbar>
    </div>
  );
};

export default Header;
